module.exports = __webpack_public_path__ + "static/media/dashboard_phone_start.e4745cbf.png";